module.exports = __webpack_public_path__ + "media/stop-8.8eb1bbb0.mp3";